import MeetingRecapDialog from './MeetingRecapDialog';

export default MeetingRecapDialog;
